export default class Level {
    constructor() {
    }
    getLevelFromExp(exp) {
        if (!exp) exp = 0;
        var level = Math.floor(Math.pow(exp, 1 / 2) / 1.3) + 1;
        return level;
    }
    printLevels() {
        for (var i = 1; i < 2000; i += 5) {
            console.log(' exp:' + i + ' lvl:' + Level.getLevelFromExp(i));
        }
    }
    getExpNeededForLevel(lvl) {
        var exp = Math.pow(((lvl - 1) * 1.3), 2);
        return exp;
        //for (var i = 1; i < 45; i += 1) { console.log('lvl:'+i + ' exp:' + getExpNeededForLevel(i)); }
    }

}